export enum StylesSubjectTypesApiEnum {
    TEMPLATE = 'TEMPLATE',
    CHART = 'CHART'
}

